import { FloorShape } from "src/shared/models/floorPlan";

export enum FloorAnalyticsView {
  ANALYTICS_VIEW = "1",
  PLAYBACK_VIEW_MOTION = "2",
  PLAYBACK_VIEW_LIGHT_STATUS = "3",
}

export enum AnimationPlayerTitle {
  HEATMAP = "Heatmap Animation Player",
  LIGHT_OP_STATUS = "Light Status Animation Player",
}

export interface CanvasDimensions {
  width: number;
  height: number;
}

export interface HoverState {
  visible: boolean;
  x: number;
  y: number;
}

export interface LabelDynamics {
  fontSize: number;
  height: number;
  yOffset: number;
  padding: number;
  textPadding: number;
  strokeWidth: number;
  cornerRadius: number;
  shadowBlur: number;
  shadowColor: number;
  shadowOffset: number;
}

export interface DynamicValues {
  circle: number;
  circlePositionOffset: number;
  labelDynamics: LabelDynamics;
  gateway: {
    size: number;
    offset: number;
    labelOffset: number;
  };
  photocell: {
    size: number;
    offset: number;
    labelOffset: number;
  };
}

export interface LabelLayout {
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface HeatmapMotionInfo {
  count: number | null;
  sgHour: number;
}

export interface PlayerState {
  hourRange: number;
  isPlaying: boolean;
  playbackSpeed: number;
  showPlayerControls: boolean;
  playerPosition: { x: number; y: number };
  playbackInterval: NodeJS.Timeout | null; // Add this line
}

export interface UIState {
  hoverState: HoverState;
  hovered: boolean;
  selectedWhileHovered: FloorShape | null;
  stickyNotePosition: { x: number; y: number };
}

export interface AnalyticsChartData {
  assetId: string;
  name: string;
  data: number[];
}
